import { render, staticRenderFns } from "./PreFooter.vue?vue&type=template&id=6c6ecdd2&scoped=true&"
import script from "./PreFooter.vue?vue&type=script&lang=js&"
export * from "./PreFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6ecdd2",
  null
  
)

export default component.exports